// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminUserForm-containerWith-J7sb8 {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.AdminUserForm-container-BXHBq {
    max-width: 100%;
}

/* Text - Start */

.AdminUserForm-subText-jmZoE {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.AdminUserForm-navigationLink-K3sU7 a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.AdminUserForm-navigationLink-K3sU7 a:hover,
.AdminUserForm-navigationLink-K3sU7 a:focus,
.AdminUserForm-navigationLink-K3sU7 a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.AdminUserForm-noPadding-PL0yf {
    padding: 0;
}

.AdminUserForm-heading-ig4vb {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.AdminUserForm-widthInner-_XHXw {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.AdminUserForm-noMargin-BAz0z {
    margin: 0;
}

.AdminUserForm-formControlInputTable-mhSlk {
    border: none;
    width: 100px;
    height: auto;
}

.AdminUserForm-backBtn-mfoJq {
    margin-left: 15px;
    display: inline-block;
}

.AdminUserForm-backBtn-mfoJq:active,
.AdminUserForm-backBtn-mfoJq:hover,
.AdminUserForm-backBtn-mfoJq:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.AdminUserForm-textAlignRight-zDGWP {
    text-align: right;
}

.AdminUserForm-displayInlineBlock-W8Fqs {
    display: inline-block;
}

.AdminUserForm-displayBlock-W6UQH {
    display: block;
}

.AdminUserForm-countryCode-MZ40D {
    width: 15%;
    vertical-align: top;
}

.AdminUserForm-vtrMiddle-nWjWA {
    vertical-align: middle;
}

/* commonCss */

.AdminUserForm-editIcon-qa1Rp {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.AdminUserForm-iconBtn-YXxaD,
.AdminUserForm-iconBtn-YXxaD:hover,
.AdminUserForm-iconBtn-YXxaD:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.AdminUserForm-profileImg-oGTaD {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.AdminUserForm-profileImgSection-xxYw6 {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.AdminUserForm-profileImgWidth-eIpe_ {
    margin: 0;
    max-width: 100% !important;
}

.AdminUserForm-searchInput-wbcSa {
    width: 100%;
    max-width: 320px;
}

.AdminUserForm-backgroundImg-ffJa7 {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.AdminUserForm-exportDisplay-peLVA {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.AdminUserForm-exportTextSection-FyccI {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.AdminUserForm-exportText-wzhbO {
    display: inline-block;
    padding-right: 5px;
}

.AdminUserForm-exportTextContainer-J4drN {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.AdminUserForm-vtrTextBottom-AaLKi {
    vertical-align: text-bottom;
}

.AdminUserForm-exportImg-iPvPa {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.AdminUserForm-noLink-OUOzA,
.AdminUserForm-noLink-OUOzA:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.AdminUserForm-singleCard-kcK4f {
    width: 500px;
    margin: 0 auto;
}

.AdminUserForm-defaultIcon-UnOiu {
    background-size: 50px;
}

.AdminUserForm-assignProviderSearchInput-rVWja {
    width: 100%;
    max-width: 324px;
}

.AdminUserForm-searchGroupContainer-G8DLa {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .AdminUserForm-searchGroupContainer-G8DLa {
        width: 100%;
    }

}

.AdminUserForm-card-uMj__ {
    border: 0;
    margin: 18px 0;
    border-radius: 0px;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    padding: 25px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.AdminUserForm-cardOne-K3j0i {
    border: 0;
    margin: 18px 0;
    -webkit-box-shadow: 0 6px 0 0 rgba(0, 0, 0, .01), 0 15px 32px 0 rgba(0, 0, 0, .06);
            box-shadow: 0 6px 0 0 rgba(0, 0, 0, .01), 0 15px 32px 0 rgba(0, 0, 0, .06);
    border-radius: 4px;
    background: #fff;
    padding: 25px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    border-radius: 25px;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
}

.AdminUserForm-buttonWidth-wrou1 {
    width: 200px;
}

.AdminUserForm-fullWidth-GkziY {
    width: 100% !important;
}

.AdminUserForm-btnAlignRight-JDni8 {
	float: right;
}

.AdminUserForm-textAlignRight-zDGWP {
	text-align: right;
}

.AdminUserForm-textAlignLeft-UB1V3 {
	text-align: left;
}

.AdminUserForm-modalCaptionLink-xf87R {
	color: #01A088;
}

.AdminUserForm-modalCaptionLinkLarge-ZDK7L {
	font-size: 16px;
	line-height: 32px;
}

.AdminUserForm-modalCaptionLink-xf87R:hover,
.AdminUserForm-modalCaptionLink-xf87R:focus {
	color: #01A088;
	text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/SiteAdmin/AdminCommon.css","webpack://./src/components/SiteAdmin/AdminUserForm/AdminUserForm.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kFAA0E;YAA1E,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,mBAAmB;IACnB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AC5BA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;;CAEC,cAAc;CACd,0BAA0B;AAC3B","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}",".card {\n    border: 0;\n    margin: 18px 0;\n    border-radius: 0px;\n    background: #fff;\n    display: flex;\n    justify-content: space-between;\n    padding: 25px;\n    align-items: center;\n}\n\n.cardOne {\n    border: 0;\n    margin: 18px 0;\n    box-shadow: 0 6px 0 0 rgba(0, 0, 0, .01), 0 15px 32px 0 rgba(0, 0, 0, .06);\n    border-radius: 4px;\n    background: #fff;\n    padding: 25px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 25px;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.buttonWidth {\n    width: 200px;\n}\n\n.fullWidth {\n    width: 100% !important;\n}","@import '../../Common.css';\n@import '../AdminCommon.css';\n\n.btnAlignRight {\n\tfloat: right;\n}\n\n.textAlignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.modalCaptionLink {\n\tcolor: #01A088;\n}\n\n.modalCaptionLinkLarge {\n\tfont-size: 16px;\n\tline-height: 32px;\n}\n\n.modalCaptionLink:hover,\n.modalCaptionLink:focus {\n\tcolor: #01A088;\n\ttext-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `AdminUserForm-containerWith-J7sb8`,
	"container": `AdminUserForm-container-BXHBq`,
	"subText": `AdminUserForm-subText-jmZoE`,
	"navigationLink": `AdminUserForm-navigationLink-K3sU7`,
	"noPadding": `AdminUserForm-noPadding-PL0yf`,
	"heading": `AdminUserForm-heading-ig4vb`,
	"widthInner": `AdminUserForm-widthInner-_XHXw`,
	"noMargin": `AdminUserForm-noMargin-BAz0z`,
	"formControlInputTable": `AdminUserForm-formControlInputTable-mhSlk`,
	"backBtn": `AdminUserForm-backBtn-mfoJq`,
	"textAlignRight": `AdminUserForm-textAlignRight-zDGWP`,
	"displayInlineBlock": `AdminUserForm-displayInlineBlock-W8Fqs`,
	"displayBlock": `AdminUserForm-displayBlock-W6UQH`,
	"countryCode": `AdminUserForm-countryCode-MZ40D`,
	"vtrMiddle": `AdminUserForm-vtrMiddle-nWjWA`,
	"editIcon": `AdminUserForm-editIcon-qa1Rp`,
	"iconBtn": `AdminUserForm-iconBtn-YXxaD`,
	"profileImg": `AdminUserForm-profileImg-oGTaD`,
	"profileImgSection": `AdminUserForm-profileImgSection-xxYw6`,
	"profileImgWidth": `AdminUserForm-profileImgWidth-eIpe_`,
	"searchInput": `AdminUserForm-searchInput-wbcSa`,
	"backgroundImg": `AdminUserForm-backgroundImg-ffJa7`,
	"exportDisplay": `AdminUserForm-exportDisplay-peLVA`,
	"exportTextSection": `AdminUserForm-exportTextSection-FyccI`,
	"exportText": `AdminUserForm-exportText-wzhbO`,
	"exportTextContainer": `AdminUserForm-exportTextContainer-J4drN`,
	"vtrTextBottom": `AdminUserForm-vtrTextBottom-AaLKi`,
	"exportImg": `AdminUserForm-exportImg-iPvPa`,
	"noLink": `AdminUserForm-noLink-OUOzA`,
	"singleCard": `AdminUserForm-singleCard-kcK4f`,
	"defaultIcon": `AdminUserForm-defaultIcon-UnOiu`,
	"assignProviderSearchInput": `AdminUserForm-assignProviderSearchInput-rVWja`,
	"searchGroupContainer": `AdminUserForm-searchGroupContainer-G8DLa`,
	"card": `AdminUserForm-card-uMj__`,
	"cardOne": `AdminUserForm-cardOne-K3j0i`,
	"buttonWidth": `AdminUserForm-buttonWidth-wrou1`,
	"fullWidth": `AdminUserForm-fullWidth-GkziY`,
	"btnAlignRight": `AdminUserForm-btnAlignRight-JDni8`,
	"textAlignLeft": `AdminUserForm-textAlignLeft-UB1V3`,
	"modalCaptionLink": `AdminUserForm-modalCaptionLink-xf87R`,
	"modalCaptionLinkLarge": `AdminUserForm-modalCaptionLinkLarge-ZDK7L`
};
module.exports = ___CSS_LOADER_EXPORT___;
